import { render, staticRenderFns } from "./productSeckillOrderTable.vue?vue&type=template&id=99be51aa&scoped=true"
import script from "./productSeckillOrderTable.vue?vue&type=script&lang=js"
export * from "./productSeckillOrderTable.vue?vue&type=script&lang=js"
import style0 from "./productSeckillOrderTable.vue?vue&type=style&index=0&id=99be51aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99be51aa",
  null
  
)

export default component.exports